"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const SPACING_XXS = '4px';
const SPACING_XS = '8px';
const SPACING_SM = '12px';
const SPACING_MD = '20px';
const SPACING_LG = '40px';
const SPACING_XL = '80px';
const SPACING_XXL = '120px';
const SPACING_10 = '10px';
const SPACING_16 = '16px';
const SPACING_24 = '24px';
const SPACING_32 = '32px';
const SPACING = {
  XXS: SPACING_XXS,
  XS: SPACING_XS,
  SM: SPACING_SM,
  MD: SPACING_MD,
  LG: SPACING_LG,
  XL: SPACING_XL,
  XXL: SPACING_XXL,
  S10: SPACING_10,
  S16: SPACING_16,
  S24: SPACING_24,
  S32: SPACING_32
};
var _default = SPACING;
exports.default = _default;